import React from 'react';
import { Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { LoadingSpinner, DataTable, columnTypes } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
    margin-right: auto;
    margin-left: auto;
    display: flex;
    flex-direction: column;
`;
const StyledRow = styled(Row)`
    @media (min-width: 992px) {
        height: 100%;
        overflow: hidden;
    }
`;
const StyledCol = styled(Col)`
    margin-bottom: 10px;
    @media (min-width: 992px) {
        height: 100%;
        overflow: auto;
        margin-bottom: 0;
    }
`;

const columns = [
    { id: 'key', title: 'key', type: columnTypes.TEXT },
    { id: 'value', title: 'value', type: columnTypes.TEXT },
];

const walkTranslationObject = (obj, str, returnValue) => {
    Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === 'object') {
            walkTranslationObject(obj[key], `${str}${str.length ? '.' : ''}${key}`, returnValue);
        } else if (typeof obj[key] === 'string') {
            returnValue.push({ key: `${str}${str.length ? '.' : ''}${key}`, value: obj[key] });
        }
    });
    return returnValue;
};

const I18nExplode = () => {
    const { i18n, ready } = useTranslation();

    if (!ready) return <LoadingSpinner />;

    const translationKeysByKey = new Map();
    // Load fallback namespaces first so the default namespace wins duplicate keys.
    [...i18n.options.ns].reverse().forEach((namespace) => {
        const translations = i18n.getResourceBundle(i18n.language, namespace) || {};
        walkTranslationObject(translations, '', []).forEach((translation) => {
            translationKeysByKey.set(translation.key, translation);
        });
    });
    const translationKeys = [...translationKeysByKey.values()];

    return (
        <Container>
            <StyledRow>
                <StyledCol md={12} style={{ marginBottom: '15px' }}>
                    Note that this page will display the translation keys/values for the currently selected language, but the key is valid across all languages.<br />
                    There are <b>{translationKeys?.length} keys</b> in the library at time of load.
                </StyledCol>
            </StyledRow>
            <StyledRow>
                <StyledCol md={12}>
                    <DataTable columns={columns} rows={translationKeys} />
                </StyledCol>
            </StyledRow>
        </Container>
    );
};

I18nExplode.propTypes = {

};

export default I18nExplode;
